import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import sendDkeys from "../../common/assets/sendDkeys.png";
import indevelopment from "../../common/assets/indevelopment.png";
import mongolia from "../../common/assets/mongolia.jpg";
import uzbekistan from "../../common/assets/uzbekistan.jpg";
import s from "./CountryPlugs.module.css";
import us_mob from "../../common/assets/us_mob.jpg";
import mong_mob from "../../common/assets/mong_mob.jpg";
import armenia_mob from "../../common/assets/armenia_mob.jpg";
import armenia from "../../common/assets/armenia.jpg";
import whatsApp from "../../common/assets/whatsApp.png";
import Viber from "../../common/assets/Viber.png";
import telegram from "../../common/assets/Telegram.png";
import telephon from "../../common/assets/телефон.png";
import Map from "../../common/assets/Map.png";
const CountryPlugs = (props) => {
  const [innerWidth, setinnerWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setinnerWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let country = useParams();
  return (
    <div className={s.mainContainer}>
      {(() => {
        switch (country.id) {
          case "us":
            return (
              <div className={s.containerCountryDescription}>
                <img
                  className={s.imgCountryes}
                  src={indevelopment}
                />
                <p className={s.titlecountry}>We are currently developing and filling the page</p>
              </div>
            );
          case "bg":
            return (
              <div className={s.containerCountryDescriptionText}>
                <span
                  style={{ marginLeft: "1px" }}
                  className={`${s.dicriptionCountry} ${s.dicriptionBlodDkeys}`}
                >
                  за информация относно инсталацията, моля свържете се с нашия дилър:
                </span>

                <div className={s.containerdescription}>
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={Map}
                  />
                  <span className={`${s.dicriptionCountry}`}>
                    Адрес: гр. Пловдив, ул. Порто Лагос, 47, 4 етаж, офис 14
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={telephon}
                  />
                  <span style={{ fontWeight: "bold" }}>Телефон:</span>
                  <span className={`${s.dicriptionCountry}`}>
                    032/ 39-85-40, 032/ 39-85-41, 0895/75-21-05
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={whatsApp}
                  />
                  <img
                    className={s.iconstyle}
                    src={Viber}
                  />
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={telegram}
                  />
                  <span style={{ fontWeight: "bold" }}>Viber:</span>
                  <span className={`${s.dicriptionCountry}`}>0895752105</span>
                </div>
              </div>
            );
          case "kz":
            return (
              <div className={s.containerCountryDescriptionText}>
                <span
                  style={{ marginLeft: "1px" }}
                  className={`${s.dicriptionCountry} ${s.dicriptionBlodDkeys}`}
                >
                  орнату туралы ақпарат алу үшін біздің дилерге хабарласыңыз: <br /> Для получения
                  информации об установке D-KEYS, пожалуйста, свяжитесь с нашим дилером:
                </span>
                {/* Караганда на казахском */}
                <div>
                  <div>Қарағанды қ.</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Мекен-жайы: </span>
                      <span>Қарағанды қ., Ермеков к-сі, 58/3, № 407 кеңсе</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефондар: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7212) 90-94-00, 90-95-00, 8-707-725-53-55
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Караганда на русском */}
                <div>
                  <div>г. Караганда</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Адрес: </span>
                      <span>г. Караганда, ул. Ермекова, 58/3, офис № 407</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефоны: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7212) 90-94-00, 90-95-00, 8-707-725-53-55
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Сарань на казахском */}
                <div>
                  <div>Саран қ.</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Мекен-жайы: </span>
                      <span>Саран қаласы, Ақтас кенті, Кржижановский көшесі, 25-үй.</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефондар: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (72137) 79-243, 8 (72137)79-242, +7-707-124-58-18
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Сарань на русском */}
                <div>
                  <div>г. Сарань</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Адрес: </span>
                      <span>г. Сарань, поселок Актас, ул. Кржижановского, д. 25.</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефоны: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (72137) 79-243, 8 (72137)79-242, +7-707-124-58-18
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Темиртау на казахском */}
                <div>
                  <div>Теміртау қ.</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Мекен-жайы: </span>
                      <span>Теміртау қаласы, Металлургтер даңғылы, 28-үй</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефондар: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7213)30-00-97, 7-707-656-50-07, +7-701-753-52-15
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Темиртау на русском */}
                <div>
                  <div>г. Темиртау</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Адрес: </span>
                      <span> г. Темиртау, проспект Металлургов, д. 28</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефоны: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7213)30-00-97, 7-707-656-50-07, +7-701-753-52-15
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Шымкент на казахском */}
                <div>
                  <div>Шымкент қ.</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Мекен-жайы: </span>
                      <span>Шымкент қ., Тамерлан тас жолы, 30 үй</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефондар: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7252)214-627, 212-426, 390-977
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+7960540205</span>
                  </div>
                </div>
                {/* Шымкент на русском */}
                <div>
                  <div>г. Шымкент</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Адрес: </span>
                      <span> г. Шымкент, Тамерлановское шоссе, д. 30</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефоны: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7252)214-627, 212-426, 390-977
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Кентау на казахском */}
                <div>
                  <div>Кентау қ.</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Мекен-жайы: </span>
                      <span>Кентау қаласы, Абай даңғылы, 11 үй, 51 пәтер</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефондар: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (72536)9-10-73, 8-707-504-12-55, 8-707-504-14-55
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Кентау на русском */}
                <div>
                  <div>г. Кентау</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Адрес: </span>
                      <span> г. Кентау, проспект Абая, д.11, кв.51</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефоны: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (72536)9-10-73, 8-707-504-12-55, 8-707-504-14-55
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Тараз на казахском */}
                <div>
                  <div>Тараз қ.</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Мекен-жайы: </span>
                      <span>Тараз қаласы, Абай көшесі, 98 үй, 313 кеңсе</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефондар: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7262) 433591, 8-777-946-22-33, 8-747-136-22-33
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
                {/* Тараз на русском */}
                <div>
                  <div>г. Тараз</div>
                  <div className={s.containerdescription}>
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={Map}
                    />
                    <span className={`${s.dicriptionCountry}`}>
                      <span style={{ fontWeight: "bold" }}>Адрес: </span>
                      <span> г. Тараз, ул. Абая, д.98, офис 313</span>
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={telephon}
                    />
                    <span style={{ fontWeight: "bold" }}>Телефоны: </span>
                    <span className={`${s.dicriptionCountry}`}>
                      8 (7262) 433591, 8-777-946-22-33, 8-747-136-22-33
                    </span>
                  </div>
                  <div className={s.containerdescription}>
                    <img
                      className={s.iconstyle}
                      src={whatsApp}
                    />
                    <img
                      className={s.iconstyle}
                      src={Viber}
                    />
                    <img
                      className={`${s.iconstyle} ${s.icontelegram}`}
                      src={telegram}
                    />
                    <span style={{ fontWeight: "bold" }}>Мессенджер: </span>
                    <span className={`${s.dicriptionCountry}`}>+79605402050</span>
                  </div>
                </div>
              </div>
            );
          case "ru":
            return (
              <div className={s.containerCountryDescription}>
                <img
                  className={s.imgCountryes}
                  src={sendDkeys}
                />
                <p className={s.titlecountry}>
                  Если у вас есть какие-либо вопросы по установке
                  <span style={{ whiteSpace: "nowrap" }}> D-KEYS</span>, пожалуйста, свяжитесь с
                  нашим дилером <a href="http://www.s-m-d.ru/">http://www.s-m-d.ru/</a>
                </p>
              </div>
            );
          case "ro":
            return (
              <div className={s.containerCountryDescription}>
                <img
                  className={s.imgCountryes}
                  src={indevelopment}
                />
                <p className={s.titlecountry}>We are currently developing and filling the page</p>
              </div>
            );
          case "md":
          case "ge":
            return (
              <div className={s.containerCountryDescription}>
                <img
                  src={sendDkeys}
                  className={s.imgCountryes}
                />

                <div className={s.containetText}>
                  <p className={s.titlecountry}>
                    If you have any questions about installing D-KEYS please contact our dealer
                  </p>
                  <a
                    className={s.titlecountry}
                    href={`https://www.smd.${country.id}/ `}
                  >
                    https://www.smd.{country.id}/
                  </a>
                </div>
              </div>
            );
          case "in":
          case "tr":
          case "eg":
          case "br":
            return (
              <div className={s.containerCountryDescription}>
                <img
                  className={s.imgCountryes}
                  src={indevelopment}
                />
                <p className={s.titlecountry}>We are currently developing and filling the page</p>
              </div>
            );
          case "mn":
            return (
              <div className={s.containerCountryDescriptionText}>
                <span
                  style={{ marginLeft: "1px" }}
                  className={`${s.dicriptionCountry} ${s.dicriptionBlodDkeys}`}
                >
                  суурилуулах талаарх мэдээллийг та манай дилерт хандаж авна уу:
                </span>

                <div className={s.containerdescription}>
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={Map}
                  />
                  <span className={`${s.dicriptionCountry}`}>
                    Улаанбаатар хот, Чингэлтэй дүүрэг, 4-р хороо, Барилгачдын 4/4, MAX TOWER, 3
                    давхар 303 тоот
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={telephon}
                  />
                  <span style={{ fontWeight: "bold" }}>Утас:</span>
                  <span className={`${s.dicriptionCountry}`}>70116776, 94003939, 89004039</span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={whatsApp}
                  />
                  <img
                    className={s.iconstyle}
                    src={Viber}
                  />
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={telegram}
                  />
                  <span style={{ fontWeight: "bold" }}>Чатаар холбогдох:</span>
                  <span className={`${s.dicriptionCountry}`}>85055400</span>
                </div>
              </div>
            );
          case "uz":
            return (
              <div className={s.containerCountryDescriptionText}>
                <span
                  style={{ marginLeft: "1px" }}
                  className={`${s.dicriptionCountry} ${s.dicriptionBlodDkeys}`}
                >
                  -ni o'rnatish bo'yicha savollar bo'lsa, bizning dilerimizga murojaat qiling
                </span>

                <div className={s.containerdescription}>
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={Map}
                  />
                  <span style={{ fontWeight: "bold" }}>Manzil:</span>
                  <span className={`${s.dicriptionCountry}`}>
                    Toshkent sh., Chilonzor tumani, Qatartol ko‘chasi, 60B, 506-xona (5-qavat)
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={telephon}
                  />
                  <span style={{ fontWeight: "bold" }}>Telefonlar:</span>
                  <span className={`${s.dicriptionCountry}`}>
                    (99871) 2882388, 2882398, 2733073, 2734073
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={whatsApp}
                  />
                  <img
                    className={s.iconstyle}
                    src={Viber}
                  />
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={telegram}
                  />
                  <span style={{ fontWeight: "bold" }}>Messenjerlar:</span>
                  <span className={`${s.dicriptionCountry}`}>998970091551</span>
                </div>
              </div>
            );
          case "am":
            return (
              <div className={s.containerCountryDescriptionText}>
                {/* {innerWidth > 840 ? <img className={s.imgCountry} src={armenia} /> : <img className={s.imgCountry} src={armenia_mob}/>} */}
                <span
                  style={{ marginLeft: "1px" }}
                  className={`${s.dicriptionCountry} ${s.dicriptionBlodDkeys}`}
                >
                  -ի հետ կապված հարցերով կարող եք զանգահարել մեր դիլերին
                </span>

                <div className={s.containerdescription}>
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={Map}
                  />
                  <span className={`${s.dicriptionCountry}`}>
                    հասցե՝ քաղաք Երևան, Վաղարշ Վաղարշյան փողոց 12, 4-րդ հարկ․ ձախ թև
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={telephon}
                  />
                  <span className={`${s.dicriptionCountry} ${s.dicriptionBlodPhone}`}>
                    32-00-64, 32-00-67, 27-00-64, 091-00-65-10, 095-32-00-64, 094-97-14-44,
                    099-32-00-67
                  </span>
                </div>

                <div className={s.containerdescription}>
                  <img
                    className={s.iconstyle}
                    src={whatsApp}
                  />
                  <img
                    className={s.iconstyle}
                    src={Viber}
                  />
                  <img
                    className={`${s.iconstyle} ${s.icontelegram}`}
                    src={telegram}
                  />
                  <span className={`${s.dicriptionCountry} ${s.dicriptionBlodNumber}`}>
                    +37443001272
                  </span>
                </div>
              </div>
            );
          default:
            return null; // Добавьте return null на случай, если ни одно условие не сработает
        }
      })()}
    </div>
  );
};

export default CountryPlugs;
